import * as Sentry from '@sentry/react';

const env = import.meta.env.VITE_SENTRY_ENV;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: env,
  enabled: Boolean(import.meta.env.VITE_SENTRY_DSN),
  debug: import.meta.env.DEV,
  beforeSend(event) {
    if (env === 'local' || !env) return null;
    return event;
  },
});
